import { Sort } from '../../../insight/experimental.grid';

import { ColumnType, TemplateID } from './team-grid.model';

export interface CellContext {
    templateId: TemplateID;
    data: any[];
    pillarId?: string;
}

export enum OptionalColumnType {
    ACTUAL,
    TARGET,
    PERCENT_TO_TARGET,
    WEIGHT,
    ACTUAL_TYPE,
    TARGET_TYPE,
    PERCENT_TYPE,
    SCORING_TYPE,
    USER_NAME,
    SUPERGROUP_NAME,
    ACTUAL_TREND,
    PERCENT_TO_TARGET_TREND,
    COACHING_PLAN_ACTIVE,
    METRIC_LABEL,
}
export interface OptionalColumn {
    columnType: OptionalColumnType;
    displayOrder: number;
}
export enum ColumnTypeContribution {
    ACTUAL,
    TARGET,
    TARGET_PERCENT,
    POINTS_BAND,
    WEIGHT,
    ADJUSTED_POINTS,
    RANK,
    USER_NAME,
    SUPERGROUP_NAME,
    PERIOD,
    PILLAR_NAME,
    PILLAR = 9000,
    METRIC_NAME,
}

export interface DirectReportContributionResult {
    scorecardId?: number;
    recordType: string;
    userId?: number;
    userName?: string;
    superGroupId?: number;
    superGroupName?: string;
    startDate?: string;
    endDate?: string;
    pillarId?: number;
    pillarOrder?: number;
    metricId?: number;
    metricOrder?: number;
    actual?: number;
    target?: number;
    targetPercent?: number;
    sortDefs: Sort[];
    metricName: string;
}

export interface DirectReportContributionDisplay {
    scorecardId: number;
    recordType?: string;
    userId?: number;
    userName?: string;
    superGroupId?: number;
    superGroupName?: string;
    startDate?: string;
    endDate?: string;
    period?: string;
    metrics?: DirectReportContributionMetric[];
}

export interface DirectReportContributionMetric {
    pillarId?: number;
    metricId?: number;
    metricOrder?: number;
    metricName: string;
    actual?: number;
    target?: number;
    targetPercent?: number;
}

export interface ColumnContext {
    templateId: TemplateID;
    type: ColumnType;
    nameOverride?: string;
    metricId?: string;
    pillarId?: string;
    metricName?: string;

    /** only for header-group columns */
    pillarName?: string;

    /** only for 'parent' columns.
     * marker for expandable columns */
    isExpandable?: boolean;
    isColumnExpanded?: boolean;

    /** only for 'child' columns.
     * columnId of the column that controls if this column */
    expandableSiblingColumnId?: string;

    /** only for 'child' columns.
     * marker for siblings of expandable columns */
    hasExpandableSibling?: boolean;

    /** only for 'child' columns.
     * marker for explicitly shown columns related to expandable sibling columns */
    isExplicitlyShown?: boolean;

    /** remembers if 'group' or 'child' column is hidden due to pillar filter */
    isExplicitlyHiddenForPillars?: boolean;

    /** remembers if 'group' or 'child' column is hidden due to supergroup filter */
    isExplicitlyHiddenForSuperGroup?: boolean;

    /** used by direct-report-scorecard-grid as a cheap means to mitigate refactoring
     * to ensure display order regardless of how columns are assembled */
    displayOrder?: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RowContext {
    //
}

// TODO refactor
export function retrieveContributionCellData(
    data: DirectReportContributionDisplay[],
    metricId: string,
): any {
    const mPillar = Number(metricId.split('-')[0]);
    const mId = Number(metricId.split('-')[1]);
    const item =
        metricId.split('-').length > 2 ? Number(metricId.split('-')[2]) : null;
    let metric: DirectReportContributionMetric = null;
    metric = data[0].metrics.filter(
        (m) => m.pillarId === mPillar && m.metricId === mId,
    )[0];
    if (item) {
        switch (item) {
            case ColumnType.TARGET:
                return metric?.target ? metric.target.toFixed(2) : '-';
            case ColumnType.TARGET_PERCENT:
                return metric?.targetPercent != null
                    ? (metric.targetPercent * 100).toFixed(2)
                    : '-';
            default:
                return '-';
        }
    }
    return metric.actual ? metric.actual.toFixed(2) : '-';
}
